<template>
  <v-dialog v-model="isActive" scrollable persistent>
    <v-card>
      <div>
        <v-card-title class="px-4"> Editar Veículo </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="pt-1" style="overflow: hidden">
            <v-text-field
              v-mask="'XXX-XXXX'"
              :disabled="isLoading"
              v-model="form.vehicle.vehicle_plate"
              label="*Placa"
              class="pb-4 pr-1"
              color="#777"
              hide-details
              dense
              outlined
              style="width: 35%; float: left"
            ></v-text-field>
            <v-select
              :disabled="isLoading"
              :items="form.vehicle_brands"
              v-model="form.vehicle.vehicle_brand.id"
              item-text="description"
              item-value="id"
              label="*Marca"
              class="pb-4 pl-1"
              color="#777"
              outlined
              hide-details
              dense
              style="width: 65%; float: left"
            ></v-select>
          </div>
          <div class="pt-1" style="overflow: hidden">
            <v-text-field
              :disabled="isLoading"
              v-model="form.vehicle.description"
              color="#777"
              label="*Descrição/Modelo"
              class="pb-4 pr-1"
              hide-details
              dense
              outlined
              style="width: 65%; float: left"
            ></v-text-field>
            <v-select
              :items="form.vehicle_color"
              v-model="form.vehicle.color"
              :disabled="isLoading"
              label="*Cor"
              class="pb-4 pl-1"
              color="#777"
              outlined
              hide-details
              dense
              style="width: 35%; float: left"
            ></v-select>
          </div>
          <div class="pt-1" style="overflow: hidden">
            <v-text-field
              :disabled="isLoading"
              v-model="form.vehicle.year"
              v-mask="['####']"
              color="#777"
              label="*Ano"
              class="pb-4 pr-1"
              hide-details
              dense
              outlined
              style="width: 50%; float: left"
            ></v-text-field>
            <v-text-field
              :disabled="isLoading"
              v-model="form.vehicle.year_model"
              v-mask="['####']"
              color="#777"
              label="*Ano Modelo"
              class="pl-1"
              hide-details
              dense
              outlined
              style="width: 50%; float: left"
            ></v-text-field>
          </div>
          <div style="overflow: hidden">
            <v-select
              :items="form.vehicle_fuel"
              v-model="form.vehicle.fuel"
              :disabled="isLoading"
              label="*Combustível"
              class="pb-4 pt-1"
              color="#777"
              outlined
              hide-details
              dense
            ></v-select>
            <v-text-field
              :disabled="isLoading"
              v-model="form.vehicle.chassi"
              color="#777"
              label="Chassi"
              class="pb-4 pt-1"
              hide-details
              dense
              outlined
            ></v-text-field>
          </div>
          <div class="pt-1" style="overflow: hidden">
            <v-text-field
              :disabled="isLoading"
              v-model="form.vehicle.engine_cc"
              v-mask="['####']"
              color="#777"
              label="Cilindradas"
              class="pb-4 pr-1"
              hide-details
              dense
              outlined
              style="width: 50%; float: left"
            ></v-text-field>
            <v-text-field
              :disabled="isLoading"
              v-model="form.vehicle.engine_cv"
              v-mask="['####']"
              color="#777"
              label="Cavalos"
              class="pl-1"
              hide-details
              dense
              outlined
              style="width: 50%; float: left"
            ></v-text-field>
          </div>
          <div class="pt-1 px-2" style="overflow: hidden">
            <v-switch
              :disabled="isLoading"
              v-model="form.vehicle.imported"
              label="Importado"
              class="mt-0 mb-1"
              hide-details
              style="width: 50%; float: left"
            ></v-switch>
            <v-switch
              :disabled="isLoading"
              v-model="form.vehicle.blindado"
              label="Blindado"
              class="mt-0 mb-1"
              hide-details
              style="width: 50%; float: left"
            ></v-switch>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="close()" :disabled="isLoading"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="save()" color="primary" depressed :disabled="isLoading || isSaveDisabled"> Salvar </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalEditVehicle',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    vehicle: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        vehicle: {},
        vehicle_brands: null,
        vehicle_fuel: ['Álcool / Gasolina', 'Gasolina', 'Álcool', 'Diesel', 'Gasolina/Elétrico', 'Elétrico'],
        vehicle_color: ['Prata', 'Cinza', 'Branca', 'Preta', 'Vermelha', 'Azul', 'Bege', 'Verde', 'Amarela', 'Marrom', 'Roxa']
      },
      isLoading: false
    };
  },
  computed: {
    isSaveDisabled() {
      return (
        !this.form.vehicle?.vehicle_plate ||
        !this.form.vehicle?.vehicle_brand?.id ||
        !this.form.vehicle?.description ||
        !this.form.vehicle?.color ||
        !this.form.vehicle?.year ||
        !this.form.vehicle?.year_model ||
        !this.form.vehicle?.fuel
      );
    }
  },
  watch: {
    vehicle: {
      immediate: true,
      handler() {
        this.form.vehicle = JSON.parse(JSON.stringify(this.vehicle));
      },
      deep: true
    }
  },
  mounted() {
    this.getVehicleBrands();
  },
  methods: {
    close(data) {
      this.$emit('close', data || null);
    },
    getVehicleBrands() {
      const self = this;

      self.isLoading = true;

      self.$http
        .get('/vehicle/brands')
        .then((response) => {
          self.form.vehicle_brands = response.data;
          self.isLoading = false;
        })
        .catch(() => {
          self.isLoading = false;
        });
    },
    save() {
      const self = this;

      self.isLoading = true;

      try {
        self.$http.put(`/vehicle`, { ...self.form.vehicle }).then((r) => {
          self.close(r.data.updated);
        });
      } catch (e) {
        self.isLoading = false;
      } finally {
        self.isLoading = false;
      }
    }
  }
};
</script>
